import { render, staticRenderFns } from "./addParams.vue?vue&type=template&id=6b8bfcae&scoped=true&"
import script from "./addParams.vue?vue&type=script&lang=js&"
export * from "./addParams.vue?vue&type=script&lang=js&"
import style0 from "./addParams.vue?vue&type=style&index=0&id=6b8bfcae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8bfcae",
  null
  
)

export default component.exports